import type { WorkerModuleReference } from "../types/job.js";

export type WorkerBridgeRequest<TPayload = unknown> = {
  modulePath: string;
  exportName: string;
  payload: TPayload;
  jobId: string;
  name: string;
  attempt: number;
  createdAt: string;
  startedAt: string;
};

export function normalizeWorkerReference(worker: WorkerModuleReference): {
  modulePath: string;
  exportName: string;
} {
  return {
    modulePath: worker.path instanceof URL ? worker.path.href : worker.path,
    exportName: worker.exportName ?? "default",
  };
}
